import { GlobalServices } from '../global-services';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React, { PropsWithChildren } from 'react';
import { AskBlueJApiContextProvider } from '../api/context';

type GlobalProviderProps = {
  queryClient: QueryClient;
  services: GlobalServices;
}


export function GlobalProvider({ children, queryClient, services }: PropsWithChildren<GlobalProviderProps>) {
  const askBlueJApiContextValue = {
    api: services.askBlueJApi,
    sourceApi: services.sourceApi,
    threadApi: services.threadApi,
    projectApi: services.projectApi,
    workflowsApi: services.workflowsApi,
    interactionsApi: services.interactionsApi
  };

  return (
    <QueryClientProvider client={queryClient}>
      <AskBlueJApiContextProvider value={askBlueJApiContextValue}>
        {children}
      </AskBlueJApiContextProvider>
    </QueryClientProvider>
  )
}
